{% block sw_cms_element_acris_faq_config %}
    <div class="sw-cms-el-config-acris-faq">
        <mt-select :label="$tc('acris-faq.elements.faqGroups.config.label.groupLoaded')"
                   :options="optionsGroupLoaded"
                   v-model="element.config.faqGroupLoaded.value">
        </mt-select>

        <sw-entity-multi-id-select
                v-if="element.config.faqGroupLoaded.value=='manual'"
                :repository="faqGroup"
                labelProperty="name"
                :label="$tc('acris-faq.elements.faqGroups.config.label.selectGroups')"
                :helpText="$tc('acris-faq.elements.faqGroups.config.label.helpText')"
                v-model:value="element.config.faqGroups.value">
        </sw-entity-multi-id-select>
    </div>
{% endblock %}


